import React, { Component } from 'react';
import { ToastContainer } from 'react-toastify';

export default class CustomToastContainer extends Component {
    render() {
        return (
            <ToastContainer
                autoClose={5000}
                bodyClassName="laToastBody"
                className="laToastContainer"
                closeOnClick
                pauseOnHover
                pauseOnVisibilityChange
                position="top-right"
                progressClassName="laToastProgress"
                toastClassName="laToastToast"
            />
        );
    }
}
